/* global wp */
/* global pwsL10n */
"use strict";

($dt => {

	const setPasswordMeterStatus = (elem, className, statusText) => {
		elem.className = 'd3df-password-meter ' + className;
		elem.innerHTML = statusText;
	};

	$dt.autostart.push(() => {
		//$dt.OnDevelformsReady($df => {
		$dt.OnDevelformsReady(() => {

			const form_containers = document.querySelectorAll('form.d3df_simple_wpupdatepw');
			if (form_containers.length > 0) {
				form_containers.forEach(container => {

					const [ new_password_input, confirm_password_container, confirm_password_input, password_meter, submit_button ] = [
						container.querySelector('input[name="new_password"]'),
						container.querySelector('.d3df_field_confirm_password'),
						container.querySelector('input[name="confirm_password"]'),
						document.createElement('div'),
						container.querySelector('input[type="submit"]')
					];

					if (typeof(wp) !== 'undefined' && typeof(wp.passwordStrength) !== 'undefined') {
						// Setup and add password meter
						setPasswordMeterStatus(password_meter, '', '');
						confirm_password_container.after(password_meter);

						// Set listener for new password fields
						document.addEventListener('keyup', e => {
							if (e.target === new_password_input || e.target === confirm_password_input) {
								const badwords = wp.passwordStrength.userInputDisallowedList();
								const strength = wp.passwordStrength.meter(new_password_input.value, badwords, confirm_password_input.value);
								
								switch (strength) {
									case 2:
										setPasswordMeterStatus(password_meter, 'strength-weak', pwsL10n.bad);
										break;
									case 3:
										setPasswordMeterStatus(password_meter, 'strength-fair', pwsL10n.good);
										break;
									case 4:
										setPasswordMeterStatus(password_meter, 'strength-strong', pwsL10n.strong);
										break;
									case 5:
										setPasswordMeterStatus(password_meter, 'strength-short', pwsL10n.mismatch);
										break;
									default:
										setPasswordMeterStatus(password_meter, 'strength-short', pwsL10n.short);
										break;
								}

								if (strength === 3 || strength === 4) {
									submit_button.removeAttribute('disabled');
								} else {
									submit_button.setAttribute('disabled', 'disabled');
								}
							}
						});
					} else {
						console.log('Could not initialize password strength due to missing libraries.');
					}
				});
			}
		});
	});
		
})(window.d3_wp_themejs);
